import { CrudList } from '../shared/CrudPage';
import { departmentService } from '@kss/api';
import type { Department, DepartmentCreate, DepartmentFilter } from '@kss/api';

export default function AllDepartments() {
  return (
    <CrudList<Department, DepartmentCreate, DepartmentFilter>
      title="Departments"
      newLabel="New department"
      service={departmentService}
      idKey="departmentId"
      labelKey="name"
      basePath="/panel/departments"
      columns={[
        { accessor: 'code', title: 'Code', width: 120 },
        { accessor: 'name', title: 'Name', sortable: true, filterable: true },
        { accessor: 'description', title: 'Description', render: (r) => r.description || '—' },
      ]}
    />
  );
}
